import { IGetPrepaidReloadPaymentMethodId } from '../types';

import { getValidPaymentMethodId } from './getValidPaymentMethodId';

/**
 * Prepaid payment method can be a CC, Apple or Google Pay (i.e. anything but a prepaid card)
 */
export const getPrepaidReloadPaymentMethodId = ({
  accounts,
  usersPaymentMethodId,
  canUseApplePay,
  canUseGooglePay,
  applePayCardDetails,
  googlePayCardDetails,
  isDefault
}: IGetPrepaidReloadPaymentMethodId) => {
  // TH want to auto select apple pay only if the user has no other payment methods
  const prepaidReloadAccounts = accounts;
  let userPrepaidReloadPaymentMethodId = usersPaymentMethodId;
  // The user can't have a native payment set as default
  if (!isDefault) {
    // Add Apple Pay and Google Pay to the accounts list if its enabled & not already there
    if (canUseApplePay) {
      prepaidReloadAccounts.unshift(applePayCardDetails);
    }
    if (canUseGooglePay) {
      prepaidReloadAccounts.unshift(googlePayCardDetails);
    }
  }
  // Return a valid prepaid payment method (cannot be a prepaid card)
  return getValidPaymentMethodId({
    paymentMethodId: userPrepaidReloadPaymentMethodId,
    paymentMethods: prepaidReloadAccounts.filter(method => !!method.credit)
  });
};
